import React from "react";
import Typography from "@mui/material/Typography";
import EtaStatusPill from "../../../Pills/EtaStatusPill/EtaStatusPill";
import { nullCheck } from "../../../../utils/dataHelpers";
import { parseAndFormatDate } from "../../../../utils/dateHelpers";
import { formatTitleCase } from "../../../../utils/formatHelpers";

export default function EtaStatusCell(cell) {
  const active = nullCheck(cell, false, "row", "original", "activeRow");
  const etaNextStop = parseAndFormatDate(nullCheck(cell, "", "row", "original", "newEta"), "MM/dd/yy HH:mm");
  const etaStatusHoverString = nullCheck(cell, "", "row", "original", "etaStatusHoverString");
  const exceptions = nullCheck(cell, null, "row", "original", "exceptions");
  const tabValue = nullCheck(cell, "", "column", "tabValue");
  const tooltip = tabValue !== 1 || etaStatusHoverString === "" ? etaNextStop :
    etaStatusHoverString.split("\n").map((s, i) => {
      if (i === 0) {
        return <Typography key={i} variant="h4" marginBottom="5px"><b><u>{`${formatTitleCase(s)}`}</u></b></Typography>;
      } else {
        return <Typography key={i} variant="body1" marginBottom="5px">{`${formatTitleCase(s)}`}</Typography>;
      }
    });

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      {cell.value > -1 || tabValue === 1
        ? <EtaStatusPill value={cell.value} tooltip={tooltip} exceptions={exceptions} tabValue={tabValue} />
        : <Typography variant="body1" color={active ? "white_opacity.100" : "black_solid.80"}>-</Typography>
      }
    </span>
  );
}